import { useContext } from 'react';

import Card3D from '@/components/game/3d/object/card/Card3D';
import { ViewContext } from '@/state/contexts';
import { getCardTexturePath } from '@/util/card';

const FailedContractsBuilder = ({ playerId, failedContracts }) => {
	const {
		showCardTableModal,
		setShowCardTableModal,
		cardsOnTablePlayerId,
		setCardsOnTablePlayerId,
	}: any = useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir,

	function displayCardsOnTableForPlayerId() {
		setCardsOnTablePlayerId(playerId);
		setShowCardTableModal(true);
	}

	if (failedContracts == null || failedContracts.length === 0) {
		return;
	}

	const fcArray: any = [];

	for (let z = failedContracts.length - 1; z >= 0; z--) {
		const texturePath = getCardTexturePath(failedContracts[z]);

		fcArray.push(
			<group
				key={`aca_group__${z}`}
				position={[-0.5, 0.6 + 0.8 * (z / 2), 5.25 + 1.5 * z]}
			>
				<Card3D
					key={`aca__${z}`}
					texturePath={texturePath}
					cardArr={failedContracts}
					viewCardModal={displayCardsOnTableForPlayerId}
				/>
			</group>
		);
	}

	return <>{fcArray}</>;
};

export default FailedContractsBuilder;
